import { Link } from "react-router-dom";
import { hotTypes } from "@/mocks/events";

const principles = [
  {
    n: "01",
    title: "真实，是最快的出圈密码",
    desc: "不修的现场、不演的日常、不包装的手艺，往往比精致的“人设”更有穿透力。观众要的是能被信任的真实。",
  },
  {
    n: "02",
    title: "共鸣，比流量更持久",
    desc: "让普通人从中看到自己——早高峰、租房、养猫、返乡——情绪共鸣会替内容完成剩下的传播，也让热度不只是一阵风。",
  },
  {
    n: "03",
    title: "专注，让小人物的手艺闪光",
    desc: "把一门手艺做到极致，本身就是稀缺内容。技能型主角正用肉眼可见的功力，赢得尊重与长久的喜爱。",
  },
];

export default function RulesBand() {
  return (
    <section className="w-full bg-background-50">
      <div className="container-x py-14 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div className="relative overflow-hidden rounded-lg bg-background-200 lg:aspect-[6/5] lg:max-h-[520px]">
            <img
              src="https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20small%20figure%20climbing%20upward%20steps%20lit%20by%20a%20single%20spotlight%20with%20ascending%20arrows%20and%20tiny%20flames%20behind%2C%20textured%20gouache%20on%20cream%20paper%2C%20muted%20terracotta%20amber%20and%20ink%20palette%2C%20magazine%20cover%20art%2C%20generous%20negative%20space%2C%20metaphor%20for%20rising%20to%20fame&width=1200&height=900&seq=rule-band-01&orientation=portrait"
              alt="素人走向爆红的出圈路径插画"
              title="素人出圈路径"
              className="h-full w-full object-cover object-top"
            />
            <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 font-label text-xs font-medium text-background-950">
              <i className="ri-lightbulb-line" aria-hidden="true" />
              吃瓜冷知识
            </span>
          </div>

          <div>
            <span className="eyebrow">
              <i className="ri-compass-3-line" aria-hidden="true" />
              爆红人物走红事件解码
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              为什么是“他们”突然走红？
              <br />
              我们总结出三条出圈法则
            </h2>
            <div className="mt-8 space-y-7">
              {principles.map((r) => (
                <div key={r.n} className="flex gap-5">
                  <span className="font-heading text-2xl font-black leading-none text-primary-500">{r.n}</span>
                  <div>
                    <h3 className="font-label text-[15px] font-semibold text-foreground-950">{r.title}</h3>
                    <p className="mt-1.5 text-sm leading-7 text-foreground-700">{r.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 rounded-lg border border-background-200 bg-background-100/60 p-6 md:p-8">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <h3 className="font-heading text-xl font-bold text-foreground-950">按栏目追更热门主角</h3>
            <Link to="/renwu" className="font-label text-sm text-primary-600 hover:text-primary-700 cursor-pointer">
              去主角档案看看 <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>
          <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
            {hotTypes.map((t) => (
              <Link
                to="/renwu"
                key={t.key}
                className="group rounded-md border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 cursor-pointer"
              >
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                  <i className="ri-apps-2-line" aria-hidden="true" />
                </span>
                <h4 className="mt-3 font-label text-sm font-semibold text-foreground-950 group-hover:text-primary-700">
                  {t.label}
                </h4>
                <p className="mt-1.5 line-clamp-2 text-xs leading-5 text-foreground-600">{t.desc}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}